exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".registerAuthModalData[data-v-82863748]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.registerAuthModalData__header[data-v-82863748]{font-size:19px;text-align:center;padding-bottom:20px;font-weight:400;font-family:Montserrat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-82863748","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/modules/register_auth_modal/RegisterAuthModal.vue
// module id = 69acb4618b164dbc1a34
// module chunks = 8